export const customSessionStorage = {
  getItem: (key: string) => sessionStorage.getItem(key),
  setItem: (key: string, value: string) => {
    sessionStorage.setItem(key, value)
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: key,
        newValue: value,
        oldValue: sessionStorage.getItem(key),
        storageArea: sessionStorage,
      }),
    )
  },
  removeItem: (key: string) => sessionStorage.removeItem(key),
}
